import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";

export const MESSAGE_SLICE_NAME = "message";

interface sendMessageParams {
  chat: number;
  message: string;
  file: File | null;
  onSuccess?: () => void;
}

export const sendMessageAsync = createAsyncThunk(
  `${MESSAGE_SLICE_NAME}/sendMessage`,
  async (params: sendMessageParams, { rejectWithValue }) => {
    try {
      const { onSuccess, ...message } = params;

      await instance.post("/messages/", message);

      onSuccess();
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.sendMessage);

      return rejectWithValue(errorText);
    }
  }
);
